import React, { FC, Fragment, useEffect } from 'react'
import { Snackbar } from '@mui/material'
import { ReactComponent as CloseIcon } from '../../assets/images/icons/error-close.svg'
import './snack-bar.scss'

export interface SnackBarProps {
    message: string
    type: 'error' | 'info'
}

const SnackBar: FC<SnackBarProps> = ({ message, type }) => {
    const [open, setOpen] = React.useState(false)
    useEffect(() => {
        if (message) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [message])

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: string
    ) => {
        if (reason === 'clickaway') {
            return
        }
        setOpen(false)
    }

    const action = (
        <Fragment>
            {type === 'error' && (
                <CloseIcon
                    onClick={handleClose}
                    className={`${type} cursor-pointer`}
                />
            )}
        </Fragment>
    )

    return (
        <div>
            {message && (
                <Snackbar
                    className={type}
                    open={open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    message={message}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    action={action}
                />
            )}
        </div>
    )
}

export default SnackBar
